import React from 'react';
import Layout from "./layout";
import Method from "./components/Method";

const Authentication = (props) => {
    return (
        <Layout children={props.children} location={props.location}>
            <div className="row">
                <div className="col-md-8">
                    <h1>Authentication </h1>
                    <br/>

                    <h2 className="h3">Create New Key</h2>
                    <br/>
                    <p>
                        The Biteshipi API uses API keys to authenticate your requests. You can manage your API keys
                        through Biteship Dashboard. Please make sure you have registered as user when creating a new key.
                        You can create new key under Integration page, this menu can be found from the dashboard's sidebar.
                    </p>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">Usage</h2>
                    <br/>
                    <p>
                        Biteship API accepts an <b>API Key Bearer Token</b> authentication method.
                        In short, you will use your Auth Token as the password for HTTP Basic authentication with Biteship.
                    </p>
                    <p>
                        Note that Biteship Auth Token will have <b>​SFT.​ </b>as prefix in every token issued and token identifier called token Id to help you manage your API keys.
                    </p>
                    <Method title={"API REQUEST"}>
                        <p className="text-white-50">curl --request POST \ <br/>
                            --url https://api.biteship.com/v1/rates/couriers \ <br/>
                            --header 'authorization: <text className="text-swift-pink"><b>{`{YOUR_API_KEY}`}</b></text> \ <br/>
                            --header 'content-type: application/json' \<br/>
                            --data ''
                        </p>
                    </Method>
                </div>
            </div>
            <br/>
        </Layout>
    )
};

export default Authentication
